import { CircleNotch } from './icons';
import { cn } from './cn';

export function Spinner({ className }: { className?: string }) {
  return <CircleNotch aria-hidden className={cn('size-4 animate-spin', className)} />;
}

export function FullscreenSpinner({ label = 'Carregando…' }: { label?: string }) {
  return (
    <div role="status" className="flex h-full min-h-screen items-center justify-center gap-3 text-fg-subtle">
      <Spinner className="size-5 text-brand-300" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
